import { render, staticRenderFns } from "./CustomizedFields.vue?vue&type=template&id=adeaa2b2&scoped=true"
import script from "./CustomizedFields.vue?vue&type=script&lang=js"
export * from "./CustomizedFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeaa2b2",
  null
  
)

export default component.exports